module.exports = __webpack_public_path__ + "media/images/tutors/PrepWorks-Nadia-Crowe-434c56785700e3f8838917505fcab103.jpg";